import React, { useState, useEffect, useRef } from 'react';

// ── CONSTANTS ──────────────────────────────────────────────────────────────
const PLAN_META = {
  pro:      { label:'Brand Pro',    color:'#06B6D4', bg:'rgba(6,182,212,0.1)',    border:'rgba(6,182,212,0.25)',    desc:'50 generations per year · All 10 phases · Priority processing' },
  studio:   { label:'Brand Studio', color:'#1A6AFF', bg:'rgba(26,106,255,0.1)',   border:'rgba(26,106,255,0.25)',   desc:'Full brand system · Logo · Website' },
  discover: { label:'Discover',     color:'#8B5CF6', bg:'rgba(139,92,246,0.1)',   border:'rgba(139,92,246,0.25)',   desc:'Strategy outputs · Watermarked exports' },
  none:     { label:'No Plan',      color:'#6B7280', bg:'rgba(107,114,128,0.1)',  border:'rgba(107,114,128,0.25)', desc:'Visit brandostro.com to get started' },
};

const ACTION_META = {
  full_generation:    { label:'Brand Generated',   icon:'✦', color:'#1A6AFF' },
  refinement:         { label:'Phase Refined',      icon:'↺', color:'#06B6D4' },
  logo_generation:    { label:'Logo Created',       icon:'◎', color:'#8B5CF6' },
  website_generation: { label:'Website Built',      icon:'⊞', color:'#10B981' },
};

const LOGO_PATH = "M1738.97 674.63c90.78,-4.22 183.48,27.17 251.43,104.4 15.94,18.13 41.91,69.3 1.62,72.16 -46.02,3.27 -88.76,-125.46 -251.31,-116.94 -114.81,6.03 -237.3,86.41 -251.16,229.53 -1.93,19.95 0.62,68.54 -33.13,68.9 -29.35,0.32 -33.64,-33.32 -33.64,-56.16 -0,-174.72 155.08,-294.4 316.2,-301.89zm114.25 144.02c47.75,27.89 78.37,70.83 93.94,123.44 13.66,46.13 14.63,94.59 4.24,123.39 -10.33,28.65 -55.47,20.8 -55.57,-6.74 -0.26,-75.01 -3.67,-164.23 -88.44,-191.35 -48.39,-15.48 -100.32,1.85 -148.54,8.5 -25.39,3.5 -43.85,-31.11 -23.74,-50.24 45.47,-43.25 164.09,-38.55 218.1,-7.01zm-14.55 333.77c-7,166.5 -53.94,185.3 -78.63,170.78 -21.44,-12.62 -11.51,-37.15 -0.76,-64.82 28.36,-72.98 -15.04,-249.87 46.72,-250.26 46.83,-0.3 33.71,119.34 32.66,144.3zm-121.88 -156.07c-9.32,51.34 18.25,152.91 -38.33,154.46 -47.31,-4.36 -22.81,-48.24 -20.17,-106.83 1.84,-40.62 -6.2,-77.37 17.12,-105.02 26.9,-31.91 98.28,-42.1 104.03,0.05 6.44,47.22 -52.81,3.14 -62.65,57.33zm314.19 -566.85l-561.94 0c-159.7,0 -290.36,130.67 -290.36,290.36l0 560.29c0,159.7 130.67,290.36 290.36,290.36l561.94 0c159.7,0 290.36,-130.67 290.36,-290.36l0 -560.29c0,-159.7 -130.67,-290.36 -290.36,-290.36zm-455.62 789.69c-9.88,24.52 -22.66,37.91 -37.16,34.49 -37.44,-8.83 -26.27,-63.83 -18.13,-91.01 18.44,-61.61 17,-75.47 13.24,-125.89 -4.53,-60.75 9.89,-130.66 49.18,-127.92 23.23,1.62 28.87,15.8 28.42,28.18 -0.78,21.37 -17.34,55.06 -18.04,96.04 -1.02,59.72 8.02,122.74 -17.51,186.11zm311.8 -12.58c3.61,-30.19 1.67,-52.98 15.57,-56.77 18.56,-5.07 42.56,-2.65 44.17,19.27 1.62,21.97 -0.66,42.51 -2.24,59.5 -3.87,41.59 -12.09,67.59 -45.35,62.49 -44.91,-6.88 -14.98,-60.73 -12.15,-84.49zm-432.99 -118.89c17.43,0 31.55,14.13 31.55,31.56 0,17.43 -14.13,31.55 -31.55,31.55 -17.43,0 -31.56,-14.13 -31.56,-31.55 0,-17.43 14.13,-31.56 31.56,-31.56zm236.11 150.43c0.51,39.89 -16.95,103.01 -53.06,82.76 -24.94,-13.99 -10.91,-44.76 -4.19,-66.24 9.98,-31.89 20.3,-47.06 40.38,-42.39 14.26,3.31 16.68,10.73 16.87,25.86zm323.94 -245.56c-3.41,-35.22 -4.16,-71.05 20.79,-76.17 58.55,-15.81 63.11,247.5 -0.69,231.18 -20.13,-5.15 -24.09,-17.31 -22.95,-36.89 0.66,-11.4 3.05,-25.32 4.98,-41.82 3.4,-29.04 0.62,-47.84 -2.14,-76.29z";

// ── HELPERS ────────────────────────────────────────────────────────────────
function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return 'Just now';
  if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff/86400)}d ago`;
  return d.toLocaleDateString('en-GB', { day:'numeric', month:'short', year:'numeric' });
}

function getGreeting() {
  return 'Hello';
}

function getFirstName(email) {
  if (!email) return '';
  const local = email.split('@')[0];
  return local.charAt(0).toUpperCase() + local.slice(1).split(/[._-]/)[0];
}

function downloadCSV(generations) {
  const header = 'Date,Brand,Action,Plan\n';
  const rows = generations.map(g =>
    `${new Date(g.created_at).toLocaleDateString()},${g.brand_name || ''},${ACTION_META[g.action]?.label || g.action},${PLAN_META[g.plan]?.label || g.plan}`
  ).join('\n');
  const blob = new Blob([header + rows], { type:'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = 'brandostro-activity.csv';
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

// ── STYLES ─────────────────────────────────────────────────────────────────
const S = `
  @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600&display=swap');

  @keyframes fadeUp   { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
  @keyframes shimmer  { from{background-position:200% 0} to{background-position:-200% 0} }
  @keyframes pulse    { 0%,100%{opacity:1} 50%{opacity:0.5} }
  @keyframes spin     { to{transform:rotate(360deg)} }

  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }

  .db-root {
    min-height:100vh;
    background:#F2F5FF;
    font-family:'Inter',sans-serif;
    color:#0A0A1A;
    position:relative;
    overflow-x:hidden;
  }

  /* Subtle grid pattern */
  .db-root::before {
    content:'';
    position:fixed;
    inset:0;
    pointer-events:none;
    background-image:
      linear-gradient(rgba(26,106,255,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(26,106,255,0.04) 1px, transparent 1px);
    background-size:48px 48px;
    z-index:0;
  }

  /* Ambient glow */
  .db-root::after {
    content:'';
    position:fixed;
    top:-20%;
    right:-10%;
    width:600px;
    height:600px;
    background:radial-gradient(circle, rgba(26,106,255,0.08) 0%, transparent 70%);
    pointer-events:none;
    z-index:0;
  }

  /* ── HEADER ── */
  .db-header {
    position:sticky;
    top:0;
    z-index:100;
    background:#050C1A;
    backdrop-filter:blur(20px);
    -webkit-backdrop-filter:blur(20px);
    border-bottom:1px solid rgba(255,255,255,0.08);
    height:64px;
    display:flex;
    align-items:center;
    padding:0 48px;
    justify-content:space-between;
    overflow:visible;
  }

  .db-logo {
    display:flex;
    align-items:center;
    gap:10px;
    font-family:'Space Grotesk',sans-serif;
    font-size:16px;
    font-weight:700;
    letter-spacing:-0.02em;
    color:#F2F5FF;
    text-decoration:none;
  }

  .db-nav {
    display:flex;
    align-items:center;
    gap:6px;
  }

  .db-nav-btn {
    height:34px;
    padding:0 16px;
    background:transparent;
    border:1px solid transparent;
    border-radius:8px;
    font-family:'Space Grotesk',sans-serif;
    font-size:12px;
    font-weight:500;
    color:rgba(242,245,255,0.5);
    cursor:pointer;
    transition:all 0.2s;
    letter-spacing:0.02em;
  }
  .db-nav-btn:hover { color:#F2F5FF; border-color:rgba(255,255,255,0.1); background:rgba(255,255,255,0.04); }
  .db-nav-btn.active { color:#F2F5FF; border-color:rgba(26,106,255,0.4); background:rgba(26,106,255,0.1); }

  .db-nav-cta {
    height:34px;
    padding:0 18px;
    background:linear-gradient(135deg,#094BCC,#1A6AFF);
    border:none;
    border-radius:8px;
    font-family:'Space Grotesk',sans-serif;
    font-size:12px;
    font-weight:600;
    color:#fff;
    cursor:pointer;
    transition:all 0.2s;
    letter-spacing:0.04em;
    display:flex;
    align-items:center;
    gap:6px;
    box-shadow:0 0 20px rgba(26,106,255,0.3);
  }
  .db-nav-cta:hover { transform:translateY(-1px); box-shadow:0 4px 24px rgba(26,106,255,0.4); }

  .db-plan-pill {
    height:26px;
    padding:0 12px;
    border-radius:20px;
    font-family:'Space Grotesk',sans-serif;
    font-size:9px;
    font-weight:700;
    letter-spacing:0.1em;
    text-transform:uppercase;
    display:flex;
    align-items:center;
  }

  /* ── CONTENT ── */
  .db-content {
    position:relative;
    z-index:1;
    max-width:1200px;
    margin:0 auto;
    padding:48px 48px 80px;
  }

  /* ── HERO ── */
  .db-hero {
    margin-bottom:48px;
    animation:fadeUp 0.6s ease forwards;
  }

  .db-greeting {
    font-family:'Space Grotesk',sans-serif;
    font-size:clamp(28px,3vw,42px);
    font-weight:700;
    letter-spacing:-0.04em;
    color:#0A0A1A;
    line-height:1.1;
    margin-bottom:8px;
  }

  .db-greeting-sub {
    font-size:14px;
    color:#6B7280;
    font-weight:400;
    letter-spacing:0.01em;
  }

  /* ── STATS ROW ── */
  .db-stats {
    display:grid;
    grid-template-columns:repeat(4,1fr);
    gap:12px;
    margin-bottom:40px;
    animation:fadeUp 0.6s 0.1s ease both;
  }

  .db-stat {
    background:#FFFFFF;
    border:1px solid #E2E8F0;
    border-radius:16px;
    padding:24px;
    transition:all 0.3s;
    position:relative;
    overflow:hidden;
    box-shadow:0 1px 3px rgba(0,0,0,0.05);
  }
  .db-stat::before {
    content:'';
    position:absolute;
    top:0; left:0; right:0;
    height:1px;
    background:linear-gradient(90deg, transparent, rgba(26,106,255,0.4), transparent);
    opacity:0;
    transition:opacity 0.3s;
  }
  .db-stat:hover { border-color:#BFDBFE; background:#EFF4FF; }
  .db-stat:hover::before { opacity:1; }

  .db-stat-icon {
    font-size:18px;
    margin-bottom:12px;
    display:block;
    opacity:0.6;
  }

  .db-stat-num {
    font-family:'Space Grotesk',sans-serif;
    font-size:32px;
    font-weight:700;
    letter-spacing:-0.04em;
    color:#0A0A1A;
    line-height:1;
    margin-bottom:6px;
  }

  .db-stat-label {
    font-size:11px;
    font-weight:500;
    color:#9CA3AF;
    text-transform:uppercase;
    letter-spacing:0.1em;
  }

  /* ── TAB NAV ── */
  .db-tabs {
    display:flex;
    gap:4px;
    margin-bottom:32px;
    border-bottom:1px solid #E2E8F0;
    padding-bottom:0;
    animation:fadeUp 0.6s 0.15s ease both;
  }

  .db-tab {
    height:40px;
    padding:0 20px;
    background:transparent;
    border:none;
    border-bottom:2px solid transparent;
    font-family:'Space Grotesk',sans-serif;
    font-size:13px;
    font-weight:500;
    color:#6B7280;
    cursor:pointer;
    transition:all 0.2s;
    margin-bottom:-1px;
    letter-spacing:0.02em;
  }
  .db-tab:hover { color:#374151; }
  .db-tab.active { color:#0A0A1A; border-bottom-color:#1A6AFF; }

  /* ── BRAND CARDS ── */
  .db-brands-grid {
    display:grid;
    grid-template-columns:repeat(auto-fill,minmax(320px,1fr));
    gap:16px;
    animation:fadeUp 0.6s 0.2s ease both;
  }

  .db-brand-card {
    background:#FFFFFF;
    border:1px solid #E2E8F0;
    border-radius:20px;
    overflow:hidden;
    cursor:pointer;
    transition:all 0.3s;
    position:relative;
    box-shadow:0 1px 3px rgba(0,0,0,0.05);
  }
  .db-brand-card:hover {
    border-color:#BFDBFE;
    background:#F8FAFF;
    transform:translateY(-2px);
    box-shadow:0 8px 24px rgba(0,0,0,0.08);
  }

  .db-card-accent {
    height:3px;
    width:100%;
  }

  .db-card-body {
    padding:24px;
  }

  .db-card-top {
    display:flex;
    align-items:flex-start;
    gap:16px;
    margin-bottom:16px;
  }

  .db-card-logo {
    width:52px;
    height:52px;
    border-radius:12px;
    overflow:hidden;
    flex-shrink:0;
    border:1px solid rgba(255,255,255,0.1);
    display:flex;
    align-items:center;
    justify-content:center;
    font-family:'Space Grotesk',sans-serif;
    font-size:20px;
    font-weight:700;
    color:#fff;
  }

  .db-card-name {
    font-family:'Space Grotesk',sans-serif;
    font-size:20px;
    font-weight:700;
    letter-spacing:-0.03em;
    color:#0A0A1A;
    line-height:1.1;
    margin-bottom:4px;
  }

  .db-card-date {
    font-size:11px;
    color:#9CA3AF;
  }

  .db-card-brief {
    font-size:13px;
    color:#6B7280;
    line-height:1.6;
    margin-bottom:20px;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }

  .db-card-footer {
    display:flex;
    align-items:center;
    justify-content:space-between;
  }

  .db-card-open {
    font-family:'Space Grotesk',sans-serif;
    font-size:12px;
    font-weight:600;
    color:#1A6AFF;
    letter-spacing:0.04em;
    display:flex;
    align-items:center;
    gap:4px;
    transition:gap 0.2s;
  }
  .db-brand-card:hover .db-card-open { gap:8px; }

  /* New brand card */
  .db-new-card {
    background:transparent;
    border:1.5px dashed #E2E8F0;
    border-radius:20px;
    min-height:200px;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    gap:12px;
    cursor:pointer;
    transition:all 0.3s;
  }
  .db-new-card:hover { border-color:#BFDBFE; background:#EFF4FF; }

  .db-new-icon {
    width:48px;
    height:48px;
    border-radius:50%;
    background:#EFF4FF;
    border:1px solid #BFDBFE;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:20px;
    color:#1A6AFF;
    transition:all 0.3s;
  }
  .db-new-card:hover .db-new-icon { background:rgba(26,106,255,0.2); transform:scale(1.1); }

  .db-new-label {
    font-family:'Space Grotesk',sans-serif;
    font-size:13px;
    font-weight:600;
    color:#9CA3AF;
    transition:color 0.3s;
  }
  .db-new-card:hover .db-new-label { color:#374151; }

  /* ── ACTIVITY TABLE ── */
  .db-activity {
    animation:fadeUp 0.6s 0.2s ease both;
  }

  .db-activity-header {
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-bottom:20px;
  }

  .db-activity-title {
    font-family:'Space Grotesk',sans-serif;
    font-size:14px;
    font-weight:600;
    color:#9CA3AF;
    text-transform:uppercase;
    letter-spacing:0.1em;
  }

  .db-csv-btn {
    height:32px;
    padding:0 14px;
    background:transparent;
    border:1px solid #E2E8F0;
    border-radius:8px;
    font-family:'Space Grotesk',sans-serif;
    font-size:11px;
    font-weight:600;
    color:#6B7280;
    cursor:pointer;
    transition:all 0.2s;
    letter-spacing:0.04em;
  }
  .db-csv-btn:hover { color:#0A0A1A; border-color:#D1D5DB; }

  .db-table {
    background:#FFFFFF;
    border:1px solid #E2E8F0;
    border-radius:16px;
    overflow:hidden;
    box-shadow:0 1px 3px rgba(0,0,0,0.05);
  }

  .db-table-head {
    display:grid;
    grid-template-columns:1.2fr 1.8fr 1.2fr 1fr 0.8fr;
    padding:14px 24px;
    border-bottom:1px solid #E2E8F0;
    background:#F8FAFF;
  }

  .db-th {
    font-size:10px;
    font-weight:600;
    color:#9CA3AF;
    text-transform:uppercase;
    letter-spacing:0.12em;
  }

  .db-table-row {
    display:grid;
    grid-template-columns:1.2fr 1.8fr 1.2fr 1fr 0.8fr;
    padding:16px 24px;
    border-bottom:1px solid #F3F4F6;
    align-items:center;
    transition:background 0.2s;
  }
  .db-table-row:last-child { border-bottom:none; }
  .db-table-row:hover { background:#F8FAFF; }

  .db-td { font-size:13px; color:#6B7280; }
  .db-td-name { font-family:'Space Grotesk',sans-serif; font-size:14px; font-weight:600; color:#0A0A1A; }
  .db-td-date { font-size:12px; color:#9CA3AF; }

  .db-action-badge {
    display:inline-flex;
    align-items:center;
    gap:6px;
    font-size:11px;
    font-weight:600;
    padding:4px 10px;
    border-radius:20px;
    letter-spacing:0.04em;
  }

  /* ── PLAN CARD ── */
  .db-plan-card {
    background:#FFFFFF;
    border:1px solid #E2E8F0;
    border-radius:20px;
    padding:32px;
    box-shadow:0 1px 3px rgba(0,0,0,0.05);
    animation:fadeUp 0.6s 0.2s ease both;
  }

  /* ── SUPPORT ── */
  .db-support {
    animation:fadeUp 0.6s 0.2s ease both;
  }

  .db-support-grid {
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:16px;
    margin-bottom:24px;
  }

  .db-faq-item {
    background:#FFFFFF;
    border:1px solid #E2E8F0;
    border-radius:14px;
    padding:20px;
    cursor:pointer;
    transition:all 0.2s;
    box-shadow:0 1px 3px rgba(0,0,0,0.04);
  }
  .db-faq-item:hover { border-color:#BFDBFE; background:#EFF4FF; }

  .db-faq-q {
    font-family:'Space Grotesk',sans-serif;
    font-size:14px;
    font-weight:600;
    color:#0A0A1A;
    margin-bottom:8px;
  }

  .db-faq-a {
    font-size:13px;
    color:#6B7280;
    line-height:1.6;
  }

  .db-contact-card {
    background:linear-gradient(135deg,rgba(26,106,255,0.1),rgba(6,182,212,0.05));
    border:1px solid rgba(26,106,255,0.2);
    border-radius:20px;
    padding:32px;
    display:flex;
    align-items:center;
    gap:32px;
  }

  .db-contact-left { flex:1; }

  .db-contact-title {
    font-family:'Space Grotesk',sans-serif;
    font-size:20px;
    font-weight:700;
    letter-spacing:-0.02em;
    color:#0A0A1A;
    margin-bottom:8px;
  }

  .db-contact-sub {
    font-size:13px;
    color:#6B7280;
    line-height:1.6;
    margin-bottom:20px;
  }

  .db-msg-input {
    width:100%;
    background:#F8FAFF;
    border:1px solid #E2E8F0;
    border-radius:10px;
    padding:12px 16px;
    font-family:'Inter',sans-serif;
    font-size:13px;
    color:#0A0A1A;
    margin-bottom:10px;
    outline:none;
    transition:border-color 0.2s;
    resize:none;
    min-height:80px;
  }
  .db-msg-input::placeholder { color:#9CA3AF; }
  .db-msg-input:focus { border-color:#BFDBFE; box-shadow:0 0 0 3px rgba(26,106,255,0.08); }

  .db-send-btn {
    height:40px;
    padding:0 24px;
    background:linear-gradient(135deg,#094BCC,#1A6AFF);
    border:none;
    border-radius:8px;
    font-family:'Space Grotesk',sans-serif;
    font-size:13px;
    font-weight:600;
    color:#fff;
    cursor:pointer;
    transition:all 0.2s;
  }
  .db-send-btn:hover { transform:translateY(-1px); box-shadow:0 4px 20px rgba(26,106,255,0.3); }

  /* ── EMPTY STATE ── */
  .db-empty {
    text-align:center;
    padding:80px 40px;
    animation:fadeIn 0.6s ease;
  }

  .db-empty-icon {
    font-size:48px;
    margin-bottom:16px;
    opacity:0.5;
  }

  .db-empty-title {
    font-family:'Space Grotesk',sans-serif;
    font-size:20px;
    font-weight:700;
    letter-spacing:-0.02em;
    color:#374151;
    margin-bottom:8px;
  }

  .db-empty-sub {
    font-size:13px;
    color:#9CA3AF;
    margin-bottom:28px;
    line-height:1.6;
  }

  /* ── LOADING ── */
  .db-spinner {
    width:32px;
    height:32px;
    border:2px solid rgba(26,106,255,0.15);
    border-top-color:#1A6AFF;
    border-radius:50%;
    animation:spin 1s linear infinite;
    margin:0 auto 16px;
  }

  @media (max-width:900px) {
    .db-header { padding:0 20px; height:56px; }
    .db-logo { font-size:14px; gap:8px; flex-shrink:0; }
    .db-nav { gap:6px; overflow:hidden; }
    .db-nav-btn { display:none; }
    .db-plan-pill { display:none; }
    .db-content { padding:28px 20px 60px; }
    .db-stats { grid-template-columns:repeat(2,1fr); gap:10px; margin-bottom:28px; }
    .db-brands-grid { grid-template-columns:1fr; }
    .db-support-grid { grid-template-columns:1fr; }
    .db-contact-card { flex-direction:column; gap:20px; }
    .db-table-head { grid-template-columns:1fr 1.5fr 1.2fr; }
    .db-table-row { grid-template-columns:1fr 1.5fr 1.2fr; }
    .db-th:nth-child(4), .db-th:nth-child(5),
    .db-td:nth-child(4), .db-td:nth-child(5) { display:none; }
    .db-nav-btn { display:none; }
    .db-greeting { font-size:clamp(22px,5vw,32px); }
  }

  @media (max-width:600px) {
    .db-header { height:52px; padding:0 12px; flex-wrap:nowrap; overflow:visible; }
    .db-logo { font-size:13px; gap:6px; }
    .db-logo svg { width:18px; height:18px; flex-shrink:0; }
    .db-content { padding:20px 16px 60px; }
    .db-stats { grid-template-columns:repeat(2,1fr); gap:8px; margin-bottom:20px; }
    .db-stat { padding:16px; }
    .db-stat-num { font-size:24px; }
    .db-tabs { gap:0; overflow-x:auto; scrollbar-width:none; -webkit-overflow-scrolling:touch; flex-wrap:nowrap; }
    .db-tabs::-webkit-scrollbar { display:none; }
    .db-tab { flex-shrink:0; font-size:12px; padding:0 14px; }
    .db-nav-cta { height:30px; font-size:11px; padding:0 12px; }
    .db-brand-card { border-radius:14px; }
    .db-card-body { padding:16px; }
    .db-card-name { font-size:16px; }
    .db-table-head { display:none; }
    .db-table-row { grid-template-columns:1fr; gap:4px; padding:14px 16px; }
    .db-td-name { font-size:14px; margin-bottom:4px; }
    .db-td:nth-child(2) { display:block; }
    .db-td:nth-child(3) { display:block; }
    .db-td:nth-child(1), .db-td:nth-child(4), .db-td:nth-child(5) { display:none; }
    .db-empty { padding:48px 20px; }
    .db-plan-card { padding:20px; }
  }

  @media (max-width:400px) {
    .db-stats { grid-template-columns:1fr 1fr; gap:6px; }
    .db-stat { padding:14px; }
    .db-stat-num { font-size:20px; }
    .db-stat-label { font-size:9px; }
    .db-greeting { font-size:20px; }
    .db-content { padding:16px 12px 60px; }
  }
`;

// ── FAQ DATA ───────────────────────────────────────────────────────────────
const FAQS = [
  { q:'How many brands can I build?', a:'Brand Studio includes 5 complete brand sessions. Brand Pro gives you 50 generations per year under our fair use policy.' },
  { q:'Is my brand data private?', a:'Yes. Your brand data is stored securely and is only accessible to you. We never use your briefs or brand data to train our models.' },
  { q:'Can I download my brand assets?', a:'Yes. Your logo (PNG 2048px and 4096px), website HTML, and company profile are all downloadable directly from the platform.' },
  { q:'What happens if logo generation fails?', a:'Brandostro automatically retries with a refined prompt. If it still fails, your complete brand strategy, positioning, and identity system remains fully intact.' },
  { q:'Can I refine my brand after generation?', a:'Yes. Every phase has an "Edit and Refine" option that lets you provide a direction and regenerate that specific phase without rebuilding the entire brand.' },
  { q:'How do I upgrade my plan?', a:'Visit brandostro.com, click your account, and choose your new plan. Your existing brands carry over automatically.' },
];

// ─────────────────────────────────────────────────────────────────────────────
// PLAN DATA — single source of truth for all plan UI across the app
// ─────────────────────────────────────────────────────────────────────────────
const CHECKOUT = {
  studio: 'https://buy.polar.sh/polar_cl_sk7lc4uYk9oP5ae3RFWL6lwFLzj4LcSb5xnTl0xHbzA', // Brand Studio $99
  pro:    'https://buy.polar.sh/polar_cl_T7PDbvmeACaU1y4lTw2Jzsi3WwYx2k2wJlUIC4e83cM',  // Brand Pro $499
};

const PLANS = [
  {
    id:       'discover',
    name:     'Discover',
    price:    'Free',
    period:   '',
    tagline:  'Start exploring',
    gens:     '1 brand generation',
    phases:   'Phases 00–05',
    color:    '#8B5CF6',
    features: [
      '1 complete brand generation',
      'Phases 00–05 (6 phases)',
      'Name assessment & scoring',
      'Brand DNA, Identity & Messaging',
      'Visual Architecture & Positioning',
    ],
    locked: [
      'Logo generation',
      'Website generation',
      'Company Profile (PPTX)',
      'Brand Report export',
      'Phases 06–09',
    ],
  },
  {
    id:       'studio',
    name:     'Brand Studio',
    price:    '$99',
    period:   'one-time',
    tagline:  'Complete brand system',
    gens:     '5 brand generations',
    phases:   'All 10 phases',
    color:    '#1A6AFF',
    badge:    'Most popular',
    features: [
      '5 complete brand generations',
      'All 10 phases unlocked',
      'AI logo generation (Imagen 4 Ultra)',
      'Website generation (full HTML)',
      'Company Profile (8-slide PPTX)',
      'Brand Report export',
      'Full exports — all formats',
    ],
  },
  {
    id:       'pro',
    name:     'Brand Pro',
    price:    '$499',
    period:   'per year',
    tagline:  'For serious builders',
    gens:     '50 generations / year',
    phases:   'All 10 phases',
    color:    '#06B6D4',
    badge:    'Best value',
    features: [
      '50 brand generations per year',
      'All 10 phases unlocked',
      'Everything in Brand Studio',
      'Priority processing',
      'Every new feature as it ships',
      'Early access to beta features',
    ],
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// PLAN MODAL — shown when upgrading, shows correct options for current plan
// ─────────────────────────────────────────────────────────────────────────────
function PlanModal({ currentPlan, onClose }) {
  const STUDIO_URL = 'https://buy.polar.sh/polar_cl_sk7lc4uYk9oP5ae3RFWL6lwFLzj4LcSb5xnTl0xHbzA';
  const PRO_URL    = 'https://buy.polar.sh/polar_cl_T7PDbvmeACaU1y4lTw2Jzsi3WwYx2k2wJlUIC4e83cM';

  const plans = [
    {
      id: 'discover', name: 'Discover', price: 'Free', period: '', color: '#8B5CF6',
      tagline: 'Start exploring',
      features: ['1 brand generation','Phases 00–05 (6 phases)','Name assessment & brand DNA','Visual architecture & positioning'],
      locked: ['Logo generation','Website generation','Company Profile & exports','Phases 06–09'],
    },
    {
      id: 'studio', name: 'Brand Studio', price: '$99', period: 'one-time', color: '#1A6AFF',
      badge: 'Most popular', tagline: 'Complete brand system',
      url: STUDIO_URL,
      features: ['5 brand generations','All 10 phases unlocked','AI logo generation (Imagen 4 Ultra)','Website generation (full HTML)','Company Profile (8-slide PPTX)','Brand Report & full exports'],
    },
    {
      id: 'pro', name: 'Brand Pro', price: '$499', period: 'per year', color: '#06B6D4',
      badge: 'Best value', tagline: 'For serious builders',
      url: PRO_URL,
      features: ['50 brand generations per year','All 10 phases unlocked','Everything in Brand Studio','Priority processing','Every new feature as it ships'],
    },
  ];

  return (
    <div
      onClick={onClose}
      style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(4,7,13,0.8)', backdropFilter:'blur(20px)', WebkitBackdropFilter:'blur(20px)', overflowY:'auto', display:'flex', alignItems:'flex-start', justifyContent:'center', padding:'60px 24px', overflowY:'auto' }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background:'#FFFFFF', borderRadius:'24px', padding:'40px', maxWidth:'860px', width:'100%', boxShadow:'0 32px 80px rgba(0,0,0,0.3)', position:'relative', maxHeight:'calc(100vh - 96px)', overflowY:'auto' }}
      >
        <button onClick={onClose} style={{ position:'absolute', top:'16px', right:'16px', width:'32px', height:'32px', borderRadius:'50%', background:'#F3F4F6', border:'none', cursor:'pointer', fontSize:'18px', color:'#6B7280', display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>

        <div style={{ textAlign:'center', marginBottom:'32px' }}>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'26px', fontWeight:'800', letterSpacing:'-0.04em', color:'#0A0A1A', marginBottom:'6px' }}>Choose your plan</div>
          <div style={{ fontSize:'14px', color:'#6B7280' }}>Upgrade anytime. Every plan includes all future core features.</div>
        </div>

        <div className="db-inline-grid-3" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px' }}>
          {plans.map(p => {
            const isCurrent = p.id === currentPlan;
            return (
              <div key={p.id} style={{ border: isCurrent ? `2px solid ${p.color}` : '1.5px solid #E2E8F0', borderRadius:'16px', padding:'24px', background: isCurrent ? `${p.color}08` : '#FFFFFF', position:'relative' }}>
                {(p.badge || isCurrent) && (
                  <div style={{ position:'absolute', top:'-11px', left:'50%', transform:'translateX(-50%)', background: isCurrent ? p.color : '#0A0A1A', color:'#fff', fontSize:'10px', fontWeight:'700', letterSpacing:'0.1em', textTransform:'uppercase', padding:'3px 12px', borderRadius:'20px', whiteSpace:'nowrap' }}>
                    {isCurrent ? '✓ Current plan' : p.badge}
                  </div>
                )}
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'15px', fontWeight:'700', color:p.color, marginBottom:'8px' }}>{p.name}</div>
                <div style={{ display:'flex', alignItems:'baseline', gap:'4px', marginBottom:'4px' }}>
                  <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'30px', fontWeight:'800', letterSpacing:'-0.04em', color:'#0A0A1A' }}>{p.price}</span>
                  {p.period && <span style={{ fontSize:'12px', color:'#9CA3AF' }}>{p.period}</span>}
                </div>
                <div style={{ fontSize:'12px', color:'#6B7280', marginBottom:'16px' }}>{p.tagline}</div>
                <div style={{ marginBottom:'20px' }}>
                  {p.features.map((f, i) => (
                    <div key={i} style={{ display:'flex', gap:'7px', alignItems:'flex-start', marginBottom:'7px' }}>
                      <span style={{ color:p.color, fontSize:'11px', marginTop:'2px', flexShrink:0 }}>✓</span>
                      <span style={{ fontSize:'12px', color:'#374151', lineHeight:'1.4' }}>{f}</span>
                    </div>
                  ))}
                  {(p.locked || []).map((f, i) => (
                    <div key={i} style={{ display:'flex', gap:'7px', alignItems:'flex-start', marginBottom:'7px', opacity:0.35 }}>
                      <span style={{ color:'#9CA3AF', fontSize:'11px', marginTop:'2px', flexShrink:0 }}>✗</span>
                      <span style={{ fontSize:'12px', color:'#9CA3AF', lineHeight:'1.4' }}>{f}</span>
                    </div>
                  ))}
                </div>
                {isCurrent ? (
                  <div style={{ height:'40px', display:'flex', alignItems:'center', justifyContent:'center', background:`${p.color}10`, border:`1px solid ${p.color}30`, borderRadius:'10px', fontSize:'12px', fontWeight:'600', color:p.color }}>
                    Current Plan
                  </div>
                ) : p.url ? (
                  <a href={p.url} target="_blank" rel="noreferrer" onClick={onClose}
                    style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'40px', background:`linear-gradient(135deg, ${p.id === 'pro' ? '#0E7490,#06B6D4' : '#094BCC,#1A6AFF'})`, borderRadius:'10px', fontSize:'13px', fontWeight:'700', color:'#fff', textDecoration:'none', letterSpacing:'0.02em', boxShadow:`0 4px 16px ${p.color}40` }}>
                    Get {p.name} →
                  </a>
                ) : (
                  <div style={{ height:'40px', display:'flex', alignItems:'center', justifyContent:'center', background:'#F3F4F6', borderRadius:'10px', fontSize:'12px', color:'#9CA3AF' }}>
                    Free — sign up to start
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ textAlign:'center', marginTop:'24px', fontSize:'12px', color:'#9CA3AF' }}>
          Secure checkout by Polar · All prices in USD · No hidden fees
        </div>
      </div>
    </div>
  );
}



// ─────────────────────────────────────────────────────────────────────────────
// ACCOUNT PAGE — full-page settings rendered as a dashboard tab, no lightbox.
// ─────────────────────────────────────────────────────────────────────────────
function AccountPage({ session, onSignOut }) {
  const [name, setName]           = React.useState(session?.name || '');
  const [saving, setSaving]       = React.useState(false);
  const [saved, setSaved]         = React.useState(false);
  const [pwView, setPwView]       = React.useState(false);
  const [newPw, setNewPw]         = React.useState('');
  const [pwMsg, setPwMsg]         = React.useState('');
  const [pwLoading, setPwLoading] = React.useState(false);

  const initials = name
    ? name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : session?.email?.[0]?.toUpperCase() || '?';

  const handleSaveName = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      const { supabase } = await import('../supabase');
      await supabase.auth.updateUser({ data: { full_name: name } });
      setSaved(true); setTimeout(() => setSaved(false), 2000);
    } catch {}
    setSaving(false);
  };

  const handleChangePassword = async () => {
    if (newPw.length < 8) { setPwMsg('Password must be at least 8 characters.'); return; }
    setPwLoading(true); setPwMsg('');
    try {
      const { supabase } = await import('../supabase');
      const { error } = await supabase.auth.updateUser({ password: newPw });
      if (error) throw error;
      setPwMsg('Password updated successfully.');
      setNewPw('');
    } catch (err) { setPwMsg(err.message || 'Failed to update password.'); }
    setPwLoading(false);
  };

  return (
    <div className="db-plan-card">

      {/* Profile header */}
      <div style={{ display:'flex', alignItems:'center', gap:'20px', marginBottom:'40px', paddingBottom:'32px', borderBottom:'1px solid #F3F4F6' }}>
        <div style={{ width:'64px', height:'64px', borderRadius:'50%', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Space Grotesk',sans-serif", fontSize:'22px', fontWeight:'700', color:'#fff', flexShrink:0 }}>
          {initials}
        </div>
        <div>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'28px', fontWeight:'700', letterSpacing:'-0.03em', color:'#0A0A1A' }}>{name || session?.email?.split('@')[0] || 'Your Account'}</div>
          <div style={{ fontSize:'14px', color:'#9CA3AF', marginTop:'2px' }}>{session?.email}</div>
        </div>
      </div>

      {/* Name + Email */}
      <div className="db-inline-grid-2" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px', marginBottom:'20px' }}>
        <div style={{ background:'#F8FAFF', border:'1px solid #E2E8F0', borderRadius:'16px', padding:'24px' }}>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'11px', fontWeight:'600', color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:'14px' }}>Display Name</div>
          <div style={{ display:'flex', gap:'8px' }}>
            <input value={name} onChange={e => setName(e.target.value)}
              style={{ flex:1, height:'40px', padding:'0 12px', border:'1.5px solid #E2E8F0', borderRadius:'8px', fontFamily:"'Inter',sans-serif", fontSize:'14px', color:'#0A0A1A', outline:'none', background:'#fff' }}
              onFocus={e => e.target.style.borderColor='#BFDBFE'}
              onBlur={e => e.target.style.borderColor='#E2E8F0'} />
            <button onClick={handleSaveName} disabled={saving || !name.trim()}
              style={{ height:'40px', padding:'0 18px', background: saved ? '#10B981' : 'linear-gradient(135deg,#094BCC,#1A6AFF)', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'12px', fontWeight:'600', color:'#fff', cursor:'pointer', flexShrink:0, transition:'background 0.3s' }}>
              {saved ? '✓' : saving ? '…' : 'Save'}
            </button>
          </div>
        </div>
        <div style={{ background:'#F8FAFF', border:'1px solid #E2E8F0', borderRadius:'16px', padding:'24px' }}>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'11px', fontWeight:'600', color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:'14px' }}>Email Address</div>
          <div style={{ height:'40px', padding:'0 12px', background:'#fff', border:'1.5px solid #E2E8F0', borderRadius:'8px', fontSize:'13px', color:'#6B7280', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1 }}>{session?.email}</span>
            <span style={{ fontSize:'10px', color:'#9CA3AF', background:'#E2E8F0', padding:'2px 8px', borderRadius:'4px', flexShrink:0, marginLeft:'8px' }}>verified</span>
          </div>
          <div style={{ fontSize:'11px', color:'#9CA3AF', marginTop:'6px' }}>Email cannot be changed</div>
        </div>
      </div>

      {/* Password */}
      <div style={{ background:'#F8FAFF', border:'1px solid #E2E8F0', borderRadius:'16px', padding:'24px', marginBottom:'24px' }}>
        <button onClick={() => setPwView(!pwView)}
          style={{ display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', background:'transparent', border:'none', cursor:'pointer', textAlign:'left', padding:0 }}>
          <div>
            <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'15px', fontWeight:'600', color:'#0A0A1A' }}>Change Password</div>
            <div style={{ fontSize:'13px', color:'#9CA3AF', marginTop:'2px' }}>Update your account password</div>
          </div>
          <span style={{ color:'#9CA3AF', fontSize:'20px', transform: pwView ? 'rotate(90deg)' : 'none', transition:'transform 0.2s' }}>›</span>
        </button>
        {pwView && (
          <div style={{ marginTop:'18px', display:'flex', flexDirection:'column', gap:'10px' }}>
            <input type="password" placeholder="New password (min. 8 characters)"
              value={newPw} onChange={e => setNewPw(e.target.value)}
              style={{ height:'42px', padding:'0 14px', border:'1.5px solid #E2E8F0', borderRadius:'8px', fontFamily:"'Inter',sans-serif", fontSize:'14px', color:'#0A0A1A', outline:'none', background:'#fff', width:'100%', boxSizing:'border-box' }}
              onFocus={e => e.target.style.borderColor='#BFDBFE'}
              onBlur={e => e.target.style.borderColor='#E2E8F0'} />
            {pwMsg && <div style={{ fontSize:'12px', color: pwMsg.includes('success') ? '#10B981' : '#EF4444' }}>{pwMsg}</div>}
            <button onClick={handleChangePassword} disabled={pwLoading || newPw.length < 8}
              style={{ height:'40px', padding:'0 24px', alignSelf:'flex-start', background: newPw.length >= 8 ? 'linear-gradient(135deg,#094BCC,#1A6AFF)' : '#E2E8F0', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color: newPw.length >= 8 ? '#fff' : '#9CA3AF', cursor: newPw.length >= 8 ? 'pointer' : 'not-allowed' }}>
              {pwLoading ? 'Updating…' : 'Update Password'}
            </button>
          </div>
        )}
      </div>

      {/* Sign out */}
      <div style={{ borderTop:'1px solid #F3F4F6', paddingTop:'24px' }}>
        <button onClick={onSignOut}
          style={{ height:'42px', padding:'0 24px', background:'transparent', border:'1.5px solid #FECACA', borderRadius:'10px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color:'#EF4444', cursor:'pointer' }}
          onMouseEnter={e => e.target.style.background='#FEF2F2'}
          onMouseLeave={e => e.target.style.background='transparent'}>
          Sign Out
        </button>
      </div>

    </div>
  );
}

function AccountModal({ session, onClose, onSignOut }) {
  const [name, setName]           = useState(session?.name || '');
  const [saving, setSaving]       = useState(false);
  const [saved, setSaved]         = useState(false);
  const [pwView, setPwView]       = useState(false);
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw]         = useState('');
  const [pwMsg, setPwMsg]         = useState('');
  const [pwLoading, setPwLoading] = useState(false);
  const isOAuth = !session?.email?.includes('@') === false &&
    session?.email?.toLowerCase().endsWith('gmail.com') || false;

  const initials = name
    ? name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2)
    : session?.email?.[0]?.toUpperCase() || '?';

  const handleSaveName = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      const { supabase } = await import('../supabase');
      await supabase.auth.updateUser({ data: { full_name: name } });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch {}
    setSaving(false);
  };

  const handleChangePassword = async () => {
    if (newPw.length < 8) { setPwMsg('Password must be at least 8 characters.'); return; }
    setPwLoading(true);
    setPwMsg('');
    try {
      const { supabase } = await import('../supabase');
      const { error } = await supabase.auth.updateUser({ password: newPw });
      if (error) throw error;
      setPwMsg('Password updated successfully.');
      setCurrentPw(''); setNewPw('');
    } catch (err) {
      setPwMsg(err.message || 'Failed to update password.');
    }
    setPwLoading(false);
  };

  return (
    <div
      style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(4,7,13,0.75)', backdropFilter:'blur(20px)', WebkitBackdropFilter:'blur(20px)', overflowY:'auto', display:'flex', alignItems:'flex-start', justifyContent:'center', padding:'60px 24px', overflowY:'auto' }}
      onClick={onClose}
    >
      <div
        style={{ background:'#FFFFFF', borderRadius:'20px', width:'100%', maxWidth:'460px', overflow:'hidden', boxShadow:'0 24px 64px rgba(0,0,0,0.25)', maxHeight:'calc(100vh - 96px)', overflowY:'auto' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding:'28px 28px 24px', borderBottom:'1px solid #F3F4F6', display:'flex', alignItems:'center', gap:'16px' }}>
          <div style={{ width:'52px', height:'52px', borderRadius:'50%', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Space Grotesk',sans-serif", fontSize:'18px', fontWeight:'700', color:'#fff', flexShrink:0 }}>
            {initials}
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'16px', fontWeight:'700', color:'#0A0A1A', marginBottom:'2px' }}>{name || 'Your Account'}</div>
            <div style={{ fontSize:'13px', color:'#9CA3AF', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{session?.email}</div>
          </div>
          <button onClick={onClose} style={{ width:'32px', height:'32px', borderRadius:'50%', background:'#F3F4F6', border:'none', cursor:'pointer', fontSize:'18px', color:'#6B7280', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
        </div>

        {/* Body */}
        <div style={{ padding:'24px 28px' }}>

          {/* Name */}
          <div style={{ marginBottom:'20px' }}>
            <label style={{ display:'block', fontSize:'11px', fontWeight:'600', color:'#374151', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'6px' }}>Display Name</label>
            <div style={{ display:'flex', gap:'8px' }}>
              <input
                value={name}
                onChange={e => setName(e.target.value)}
                style={{ flex:1, height:'40px', padding:'0 12px', border:'1.5px solid #E2E8F0', borderRadius:'8px', fontFamily:"'Inter',sans-serif", fontSize:'14px', color:'#0A0A1A', outline:'none' }}
                onFocus={e => { e.target.style.borderColor='#BFDBFE'; }}
                onBlur={e => { e.target.style.borderColor='#E2E8F0'; }}
              />
              <button
                onClick={handleSaveName}
                disabled={saving || !name.trim()}
                style={{ height:'40px', padding:'0 16px', background: saved ? '#10B981' : 'linear-gradient(135deg,#094BCC,#1A6AFF)', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'12px', fontWeight:'600', color:'#fff', cursor:'pointer', flexShrink:0, transition:'background 0.3s' }}
              >
                {saved ? '✓ Saved' : saving ? '...' : 'Save'}
              </button>
            </div>
          </div>

          {/* Email */}
          <div style={{ marginBottom:'24px' }}>
            <label style={{ display:'block', fontSize:'11px', fontWeight:'600', color:'#374151', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'6px' }}>Email Address</label>
            <div style={{ height:'40px', padding:'0 12px', background:'#F8FAFF', border:'1.5px solid #E2E8F0', borderRadius:'8px', fontSize:'14px', color:'#6B7280', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <span>{session?.email}</span>
              <span style={{ fontSize:'10px', color:'#9CA3AF', background:'#E2E8F0', padding:'2px 8px', borderRadius:'4px' }}>verified</span>
            </div>
            <div style={{ fontSize:'11px', color:'#9CA3AF', marginTop:'4px' }}>Email cannot be changed</div>
          </div>

          {/* Password */}
          <div style={{ marginBottom:'24px' }}>
            <button
              onClick={() => setPwView(!pwView)}
              style={{ display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', padding:'12px 0', background:'transparent', border:'none', borderBottom:'1px solid #F3F4F6', cursor:'pointer', textAlign:'left' }}
            >
              <div>
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'14px', fontWeight:'600', color:'#0A0A1A' }}>Change Password</div>
                <div style={{ fontSize:'12px', color:'#9CA3AF', marginTop:'2px' }}>Update your account password</div>
              </div>
              <span style={{ color:'#9CA3AF', fontSize:'18px', transform: pwView ? 'rotate(180deg)' : 'none', transition:'transform 0.2s' }}>›</span>
            </button>

            {pwView && (
              <div style={{ marginTop:'12px', display:'flex', flexDirection:'column', gap:'8px' }}>
                <input
                  type="password" placeholder="New password (min. 8 characters)"
                  value={newPw} onChange={e => setNewPw(e.target.value)}
                  style={{ height:'40px', padding:'0 12px', border:'1.5px solid #E2E8F0', borderRadius:'8px', fontFamily:"'Inter',sans-serif", fontSize:'14px', color:'#0A0A1A', outline:'none', width:'100%', boxSizing:'border-box' }}
                  onFocus={e => { e.target.style.borderColor='#BFDBFE'; }}
                  onBlur={e => { e.target.style.borderColor='#E2E8F0'; }}
                />
                {pwMsg && <div style={{ fontSize:'12px', color: pwMsg.includes('success') ? '#10B981' : '#EF4444' }}>{pwMsg}</div>}
                <button
                  onClick={handleChangePassword}
                  disabled={pwLoading || newPw.length < 8}
                  style={{ height:'38px', background: newPw.length >= 8 ? 'linear-gradient(135deg,#094BCC,#1A6AFF)' : '#E2E8F0', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color: newPw.length >= 8 ? '#fff' : '#9CA3AF', cursor: newPw.length >= 8 ? 'pointer' : 'not-allowed' }}
                >
                  {pwLoading ? 'Updating...' : 'Update Password'}
                </button>
              </div>
            )}
          </div>

          {/* Sign out */}
          <button
            onClick={() => { onClose(); onSignOut(); }}
            style={{ width:'100%', height:'40px', background:'transparent', border:'1.5px solid #FECACA', borderRadius:'10px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color:'#EF4444', cursor:'pointer', transition:'all 0.2s' }}
            onMouseEnter={e => { e.target.style.background='#FEF2F2'; }}
            onMouseLeave={e => { e.target.style.background='transparent'; }}
          >
            Sign Out
          </button>

        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// USER MENU — Clean avatar dropdown. Professional. No clutter.
// ─────────────────────────────────────────────────────────────────────────────
function UserMenu({ session, onSignOut, currentPlan, onGoToTab }) {
  const [open, setOpen]           = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, []);

  const name = session?.name || session?.email?.split('@')[0] || 'Member';
  const initials = session?.name
    ? session.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2)
    : session?.email?.[0]?.toUpperCase() || '?';
  const plan = PLAN_META[session?.plan] || PLAN_META.none;

  return (
    <>
      <div ref={ref} style={{ position:'relative' }}>
        {/* Avatar */}
        <button
          onClick={() => setOpen(!open)}
          style={{ display:'flex', alignItems:'center', gap:'8px', background:'transparent', border:'1.5px solid rgba(255,255,255,0.15)', borderRadius:'40px', padding:'4px 10px 4px 4px', cursor:'pointer', transition:'all 0.2s' }}
          onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(255,255,255,0.35)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor='rgba(255,255,255,0.15)'; }}
        >
          <div style={{ width:'28px', height:'28px', borderRadius:'50%', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Space Grotesk',sans-serif", fontSize:'11px', fontWeight:'700', color:'#fff', flexShrink:0 }}>
            {initials}
          </div>
          <span style={{ fontSize:'12px', fontWeight:'500', color:'rgba(242,245,255,0.7)', fontFamily:"'Inter',sans-serif", maxWidth:'80px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {name.split(' ')[0]}
          </span>
          <svg width="10" height="6" viewBox="0 0 10 6" style={{ opacity:0.4, flexShrink:0, transform: open ? 'rotate(180deg)' : 'none', transition:'transform 0.2s' }}>
            <path d="M1 1l4 4 4-4" stroke="rgba(242,245,255,0.8)" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
          </svg>
        </button>

        {/* Dropdown */}
        {open && (
          <div style={{ position:'absolute', top:'calc(100% + 8px)', right:0, width:'220px', background:'#FFFFFF', border:'1px solid #E2E8F0', borderRadius:'14px', boxShadow:'0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)', zIndex:9999, overflow:'hidden' }}>

            {/* User info — header */}
            <div style={{ padding:'14px 16px 12px', borderBottom:'1px solid #F3F4F6' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Space Grotesk',sans-serif", fontSize:'12px', fontWeight:'700', color:'#fff', flexShrink:0 }}>
                  {initials}
                </div>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color:'#0A0A1A', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{name}</div>
                  <div style={{ fontSize:'11px', color:'#9CA3AF', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{session?.email}</div>
                </div>
              </div>
              {/* Plan badge */}
              <div style={{ marginTop:'8px', display:'inline-flex', alignItems:'center', gap:'5px', background:`${plan.bg}`, border:`1px solid ${plan.border}`, color:plan.color, fontSize:'10px', fontWeight:'700', letterSpacing:'0.08em', textTransform:'uppercase', padding:'3px 8px', borderRadius:'6px' }}>
                {plan.label}
              </div>
            </div>

            {/* Menu items */}
            <div style={{ padding:'6px' }}>
              <MenuItem icon="⚙" label="Account Settings" onClick={() => { setOpen(false); onGoToTab && onGoToTab('account'); }} />
              <MenuItem icon="✦" label="Manage Plan" onClick={() => { setOpen(false); onGoToTab && onGoToTab('plan'); }} />
            </div>

            <div style={{ height:'1px', background:'#F3F4F6' }} />

            <div style={{ padding:'6px' }}>
              <MenuItem
                icon="→"
                label="Sign Out"
                onClick={() => { setOpen(false); onSignOut(); }}
                danger
              />
            </div>
          </div>
        )}
      </div>

    </>
  );
}

function MenuItem({ icon, label, onClick, danger }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ width:'100%', display:'flex', alignItems:'center', gap:'10px', padding:'8px 10px', background: hover ? (danger ? '#FEF2F2' : '#F8FAFF') : 'transparent', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'13px', color: danger ? '#EF4444' : '#374151', fontFamily:"'Inter',sans-serif", textAlign:'left', transition:'all 0.15s' }}
    >
      <span style={{ fontSize:'14px', width:'16px', textAlign:'center', flexShrink:0, color: danger ? '#EF4444' : '#9CA3AF' }}>{icon}</span>
      {label}
    </button>
  );
}




const BRANDOSTRO_SYSTEM = `You are the Brandostro Assistant — the intelligent support companion built into the Brandostro platform. You are warm, knowledgeable, and direct. Keep responses concise — under 120 words unless detail is truly needed.

ABOUT BRANDOSTRO:
Brandostro is a brand intelligence platform that generates complete professional brand systems from a single sentence input in under 60 seconds. It delivers what agencies charge $75,000+ for at a fraction of the cost.

THE 10 PHASES (numbered 00–09):
00 - Nomenclature: Brand naming with trademark and domain assessment
01 - Brand DNA: Manifesto, mission, vision, values
02 - Company Identity: Purpose, origin story, belief
03 - Visual Architecture: Archetype, colour palette, typography
04 - Brand Messaging: Taglines, tone of voice, positioning, pitch scripts
05 - Strategic Positioning: Competitive landscape, perceptual map, personas, SWOT
06 - Customer Experience: Journey mapping, touchpoints, signature moments
07 - Digital Presence: AI-generated landing page (HTML), SEO foundation
08 - Go-To-Market: ICP, channel strategy, pricing logic
09 - Launch and Activation: 90-day plan, success benchmarks, PR narrative

PLANS:
- Discover (Free): 1 generation, 30 days, phases 00–05 only, no logo, no website, no exports
- Brand Studio ($99, one-time): 5 generations, 90 days, all 10 phases, logo, website, company profile, exports
- Brand Pro ($499/year): 50 generations/year, everything in Studio, priority processing, all future features
- Generation counts are plan-scoped — upgrading always starts fresh with the new plan's full allowance

LOGO: Google Imagen 4 Ultra, 3 creative directions, manual trigger, PNG 2048px + 4096px export
WEBSITE: Claude-generated HTML landing page, one generation per brand session, downloadable
COMPANY PROFILE: 8-slide PPTX — Essential 7 sections, available to Studio and Pro users
BRAND REPORT: Full text export of all strategy phases — Studio and Pro users only
BUSINESS CARD: Coming soon — print partnership in development

If someone has a technical issue that needs human attention, suggest they use the Contact Team option. Never invent features that don't exist.`;

function BrandostroAssistant({ session, engineUrl }) {
  const [view, setView]               = useState('home');
  const [messages, setMessages]       = useState([]);
  const [input, setInput]             = useState('');
  const [thinking, setThinking]       = useState(false);
  const [contactMsg, setContactMsg]   = useState('');
  const [contactSent, setContactSent] = useState(false);
  const [sending, setSending]         = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior:'smooth' });
  }, [messages, thinking]);

  const sendMessage = async (overrideInput) => {
    const text = (overrideInput || input).trim();
    if (!text || thinking) return;
    const userMsg = { role:'user', content:text };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput('');
    setThinking(true);
    try {
      const res = await fetch(`${engineUrl}/assistant`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: newMessages,
          systemContext: `USER CONTEXT — Plan: ${PLAN_META[session?.plan]?.label || 'Unknown'} · Name: ${session?.name || session?.email || 'Member'}`,
        }),
      });
      const data = await res.json();
      setMessages(prev => [...prev, { role:'assistant', content: data.content || data.error || 'Try again.' }]);
    } catch {
      setMessages(prev => [...prev, { role:'assistant', content:'Something went wrong. Please try again or use the Contact Team option.' }]);
    } finally { setThinking(false); }
  };

  const sendQuick = (q) => {
    setView('chat');
    setMessages([]);
    setTimeout(() => sendMessage(q), 50);
  };

  const sendContact = async () => {
    if (!contactMsg.trim()) return;
    setSending(true);
    try {
      await fetch(`${engineUrl}/save-support`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ memberId:session?.memberId, email:session?.email, plan:session?.plan, name:session?.name||'', message:contactMsg.trim() }),
      });
    } catch { /* still show success */ }
    setContactSent(true);
    setSending(false);
    setContactMsg('');
  };

  // ── HOME ──
  if (view === 'home') return (
    <div style={{ maxWidth:'620px' }}>
      <div style={{ display:'flex', alignItems:'center', gap:'14px', marginBottom:'20px' }}>
        <div style={{ width:'46px', height:'46px', borderRadius:'12px', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'20px', boxShadow:'0 4px 16px rgba(26,106,255,0.3)', flexShrink:0 }}>✦</div>
        <div>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'20px', fontWeight:'700', letterSpacing:'-0.02em', color:'#0A0A1A' }}>Brandostro Assistant</div>
          <div style={{ fontSize:'12px', color:'#6B7280', marginTop:'2px' }}>Powered by Claude · Answers questions instantly</div>
        </div>
      </div>

      <div className="db-inline-grid-2" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px', marginBottom:'28px' }}>
        {[
          { icon:'💬', title:'Ask the Assistant', sub:'Instant answers about Brandostro, your plan, or brand strategy.', action:() => setView('chat'), primary:true },
          { icon:'✉️', title:'Contact Our Team', sub:'Send a message. We respond within one business day.', action:() => setView('contact'), primary:false },
        ].map((o,i) => (
          <button key={i} onClick={o.action} style={{ background:'#FFFFFF', border: o.primary ? '2px solid #1A6AFF' : '1.5px solid #E2E8F0', borderRadius:'14px', padding:'20px', textAlign:'left', cursor:'pointer', transition:'all 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.background = o.primary ? '#EFF4FF' : '#F8FAFF'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#FFFFFF'; }}>
            <div style={{ fontSize:'22px', marginBottom:'8px' }}>{o.icon}</div>
            <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'14px', fontWeight:'700', color:'#0A0A1A', marginBottom:'4px' }}>{o.title}</div>
            <div style={{ fontSize:'12px', color:'#6B7280', lineHeight:'1.5' }}>{o.sub}</div>
          </button>
        ))}
      </div>

      <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'11px', fontWeight:'600', color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:'10px' }}>Common questions</div>
      {['How many brand generations do I have left?','How do I generate my logo?','What does each phase cover?','Can I upgrade my plan?'].map((q,i) => (
        <button key={i} onClick={() => sendQuick(q)} style={{ width:'100%', background:'#F8FAFF', border:'1px solid #E2E8F0', borderRadius:'10px', padding:'12px 16px', textAlign:'left', cursor:'pointer', fontSize:'13px', color:'#374151', fontFamily:"'Inter',sans-serif", transition:'all 0.2s', display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}
          onMouseEnter={e => { e.currentTarget.style.background='#EFF4FF'; e.currentTarget.style.borderColor='#BFDBFE'; }}
          onMouseLeave={e => { e.currentTarget.style.background='#F8FAFF'; e.currentTarget.style.borderColor='#E2E8F0'; }}>
          {q}<span style={{ color:'#1A6AFF', flexShrink:0, marginLeft:'8px' }}>→</span>
        </button>
      ))}
    </div>
  );

  // ── CHAT ──
  if (view === 'chat') return (
    <div style={{ maxWidth:'620px', display:'flex', flexDirection:'column', height:'calc(100vh - 260px)', minHeight:'420px' }}>
      <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'16px' }}>
        <button onClick={() => setView('home')} style={{ background:'none', border:'none', cursor:'pointer', color:'#6B7280', fontSize:'20px', padding:'2px', lineHeight:1 }}>←</button>
        <div style={{ width:'32px', height:'32px', borderRadius:'8px', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px' }}>✦</div>
        <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'15px', fontWeight:'700', color:'#0A0A1A' }}>Brandostro Assistant</div>
        <button onClick={() => setView('contact')} style={{ marginLeft:'auto', height:'30px', padding:'0 14px', background:'transparent', border:'1px solid #E2E8F0', borderRadius:'8px', fontSize:'11px', color:'#6B7280', cursor:'pointer', fontFamily:"'Space Grotesk',sans-serif", fontWeight:'500' }}>Contact Team</button>
      </div>

      <div style={{ flex:1, overflowY:'auto', display:'flex', flexDirection:'column', gap:'14px', marginBottom:'14px', paddingRight:'2px' }}>
        {messages.length === 0 && !thinking && (
          <div style={{ textAlign:'center', padding:'40px 20px', color:'#9CA3AF', fontSize:'13px' }}>Ask me anything about Brandostro...</div>
        )}
        {messages.map((m,i) => (
          <div key={i} style={{ display:'flex', justifyContent: m.role==='user'?'flex-end':'flex-start', gap:'8px', alignItems:'flex-end' }}>
            {m.role==='assistant' && <div style={{ width:'26px', height:'26px', borderRadius:'7px', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', flexShrink:0, marginBottom:'2px' }}>✦</div>}
            <div style={{ maxWidth:'78%', padding:'11px 15px', borderRadius: m.role==='user'?'14px 14px 3px 14px':'14px 14px 14px 3px', background: m.role==='user'?'linear-gradient(135deg,#094BCC,#1A6AFF)':'#FFFFFF', color: m.role==='user'?'#fff':'#0A0A1A', fontSize:'14px', lineHeight:'1.65', fontFamily:"'Inter',sans-serif", border: m.role==='assistant'?'1px solid #E2E8F0':'none', boxShadow: m.role==='assistant'?'0 1px 3px rgba(0,0,0,0.05)':'0 2px 8px rgba(26,106,255,0.2)', whiteSpace:'pre-wrap' }}>
              {m.content}
            </div>
          </div>
        ))}
        {thinking && (
          <div style={{ display:'flex', gap:'8px', alignItems:'flex-end' }}>
            <div style={{ width:'26px', height:'26px', borderRadius:'7px', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'11px', flexShrink:0 }}>✦</div>
            <div style={{ background:'#FFFFFF', border:'1px solid #E2E8F0', borderRadius:'14px 14px 14px 3px', padding:'12px 16px', display:'flex', gap:'4px' }}>
              {[0,1,2].map(i=><div key={i} style={{ width:'6px', height:'6px', borderRadius:'50%', background:'#CBD5E1', animation:'pulse 1.4s ease-in-out infinite', animationDelay:`${i*0.15}s` }}/>)}
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      <div style={{ display:'flex', gap:'8px', alignItems:'flex-end' }}>
        <textarea value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMessage();} }}
          placeholder="Ask anything..." rows={1}
          style={{ flex:1, padding:'11px 14px', border:'1.5px solid #E2E8F0', borderRadius:'12px', fontFamily:"'Inter',sans-serif", fontSize:'14px', color:'#0A0A1A', outline:'none', resize:'none', lineHeight:'1.5', maxHeight:'100px', overflowY:'auto' }}
          onFocus={e=>e.target.style.borderColor='#BFDBFE'} onBlur={e=>e.target.style.borderColor='#E2E8F0'} />
        <button onClick={()=>sendMessage()} disabled={!input.trim()||thinking}
          style={{ width:'42px', height:'42px', borderRadius:'11px', background:input.trim()&&!thinking?'linear-gradient(135deg,#094BCC,#1A6AFF)':'#E2E8F0', border:'none', cursor:input.trim()&&!thinking?'pointer':'not-allowed', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'all 0.2s' }}>
          <span style={{ color:input.trim()&&!thinking?'#fff':'#9CA3AF', fontSize:'16px' }}>↑</span>
        </button>
      </div>
      <div style={{ fontSize:'11px', color:'#CBD5E1', textAlign:'center', marginTop:'6px' }}>Enter to send · Shift+Enter for new line</div>
    </div>
  );

  // ── CONTACT ──
  if (view === 'contact') return (
    <div style={{ maxWidth:'480px' }}>
      <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'24px' }}>
        <button onClick={()=>setView('home')} style={{ background:'none', border:'none', cursor:'pointer', color:'#6B7280', fontSize:'20px', padding:'2px', lineHeight:1 }}>←</button>
        <div>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'18px', fontWeight:'700', color:'#0A0A1A' }}>Contact Our Team</div>
          <div style={{ fontSize:'12px', color:'#6B7280' }}>Responds within one business day</div>
        </div>
      </div>
      {contactSent ? (
        <div style={{ background:'#F0FDF4', border:'1px solid #BBF7D0', borderRadius:'16px', padding:'32px', textAlign:'center' }}>
          <div style={{ fontSize:'36px', marginBottom:'12px' }}>✓</div>
          <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'18px', fontWeight:'700', color:'#15803D', marginBottom:'8px' }}>Message received</div>
          <div style={{ fontSize:'14px', color:'#374151', lineHeight:'1.6', marginBottom:'20px' }}>We'll get back to you at {session?.email||'your email'} within one business day.</div>
          <button onClick={()=>{setContactSent(false);setView('home');}} style={{ height:'40px', padding:'0 24px', background:'#15803D', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color:'#fff', cursor:'pointer' }}>Back to Support</button>
        </div>
      ) : (
        <div style={{ background:'#FFFFFF', border:'1px solid #E2E8F0', borderRadius:'16px', padding:'24px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
          <div style={{ background:'#F8FAFF', border:'1px solid #E2E8F0', borderRadius:'10px', padding:'12px 14px', marginBottom:'18px', fontSize:'12px', color:'#6B7280', lineHeight:'1.6' }}>
            <div style={{ fontWeight:'600', color:'#374151', marginBottom:'3px' }}>Included automatically</div>
            <div>Name: {session?.name||'Not provided'} · Email: {session?.email||'Not provided'} · Plan: {PLAN_META[session?.plan]?.label||'Unknown'}</div>
          </div>
          <div style={{ fontSize:'11px', fontWeight:'600', color:'#374151', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'8px' }}>Your message</div>
          <textarea value={contactMsg} onChange={e=>setContactMsg(e.target.value)}
            placeholder="Describe your issue or question..."
            style={{ width:'100%', minHeight:'120px', padding:'12px 14px', border:'1.5px solid #E2E8F0', borderRadius:'10px', fontFamily:"'Inter',sans-serif", fontSize:'14px', color:'#0A0A1A', outline:'none', resize:'vertical', lineHeight:'1.6', marginBottom:'14px', boxSizing:'border-box' }}
            onFocus={e=>e.target.style.borderColor='#BFDBFE'} onBlur={e=>e.target.style.borderColor='#E2E8F0'} />
          <div style={{ display:'flex', gap:'10px' }}>
            <button onClick={sendContact} disabled={!contactMsg.trim()||sending}
              style={{ flex:1, height:'44px', background:contactMsg.trim()?'linear-gradient(135deg,#094BCC,#1A6AFF)':'#E2E8F0', border:'none', borderRadius:'10px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'14px', fontWeight:'600', color:contactMsg.trim()?'#fff':'#9CA3AF', cursor:contactMsg.trim()?'pointer':'not-allowed', transition:'all 0.2s' }}>
              {sending?'Sending…':'Send Message'}
            </button>
            <button onClick={()=>setView('chat')} style={{ height:'44px', padding:'0 18px', background:'transparent', border:'1.5px solid #E2E8F0', borderRadius:'10px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', color:'#6B7280', cursor:'pointer' }}>Ask AI</button>
          </div>
        </div>
      )}
    </div>
  );

  return null;
}

// ── MAIN DASHBOARD COMPONENT ─────────────────────────────────────────────────
export default function Dashboard({ session, engineUrl, onNewBrand, onOpenBrand, onSignOut }) {
  const [tab, setTab]             = useState('brands');
  const [brands, setBrands]       = useState([]);
  const [generations, setGenerations] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);
  const [message, setMessage]     = useState('');
  const [msgSent, setMsgSent]     = useState(false);
  const [openFaq, setOpenFaq]     = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Plan-scoped counts from /check-limit endpoint
  const [planUsed, setPlanUsed]   = useState(0);
  const [planLimitVal, setPlanLimitVal] = useState(0);

  const plan = PLAN_META[session?.plan] || PLAN_META.none;
  const firstName = session?.name?.split(' ')[0] || getFirstName(session?.email);

  // Use plan-scoped counts — upgrading always resets the counter
  const planLimit            = planLimitVal;
  const generationsUsed      = planUsed;
  const generationsRemaining = Math.max(0, planLimit - planUsed);
  const usagePercent         = planLimit > 0 ? Math.min(100, (planUsed / planLimit) * 100) : 0;
  const isLow                = generationsRemaining <= 1 && planLimit > 0;
  const isEmpty              = generationsRemaining === 0 && planLimit > 0;

  const handleNewBrand = () => {
    if (isEmpty) {
      setShowUpgradeModal(true);
      return;
    }
    onNewBrand();
  };

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const [bRes, gRes, limitRes] = await Promise.all([
        fetch(`${engineUrl}/get-brands`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ token: session?.token, memberId: session?.memberId }),
        }),
        fetch(`${engineUrl}/get-generations`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ token: session?.token, memberId: session?.memberId }),
        }),
        fetch(`${engineUrl}/check-limit`, {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ memberId: session?.memberId, plan: session?.plan }),
        }),
      ]);
      const bData = await bRes.json();
      const gData = await gRes.json();
      const lData = await limitRes.json();
      if (bData.success) setBrands(Array.isArray(bData.brands) ? bData.brands : []);
      if (gData.success) setGenerations(Array.isArray(gData.generations) ? gData.generations : []);
      // Use plan-scoped limit data
      if (lData.success) {
        setPlanUsed(lData.used || 0);
        setPlanLimitVal(lData.limit || 0);
      }
    } catch { setError('Could not load your data. Please refresh.'); }
    finally { setLoading(false); }
  };

  const openBrand = async (brandId) => {
    try {
      const res = await fetch(`${engineUrl}/get-brand`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token: session?.token, memberId: session?.memberId, brandId }),
      });
      const data = await res.json();
      if (data.success) onOpenBrand(data.brand);
    } catch (err) { console.error('Could not open brand:', err); }
  };

  const handleSendMessage = () => {
    if (!message.trim()) return;
    setMsgSent(true);
    setMessage('');
    setTimeout(() => setMsgSent(false), 4000);
  };

  const TABS = [
    { id:'brands',   label:'My Brands' },
    { id:'activity', label:'Brand Activity' },
    { id:'plan',     label:'My Plan' },
    { id:'support',  label:'Support' },
    { id:'account',  label:'Account' },
  ];

  return (
    <>
      <style>{S}</style>
      <div className="db-root">

        {/* ── HEADER ── */}
        <header className="db-header">
          <div className="db-logo">
            <img src="/assets/monogram.png" alt="Brandostro" width="30" height="30" style={{ borderRadius:'8px', flexShrink:0 }} />
            <span className="db-logo-text">Brandostro</span>
          </div>

          <nav className="db-nav">
            {TABS.map(t => (
              <button key={t.id} className={`db-nav-btn ${tab===t.id?'active':''}`} onClick={() => setTab(t.id)}>
                {t.label}
              </button>
            ))}
          </nav>

          <div style={{ display:'flex', alignItems:'center', gap:'8px', flexShrink:0, minWidth:0 }}>
            {/* Plan badge */}
            <div className="db-plan-pill" style={{ background: plan.bg, border:`1px solid ${plan.border}`, color: plan.color }}>
              {plan.label}
            </div>

            {/* New Brand button */}
            <button className="db-nav-cta" onClick={handleNewBrand}>
              <span>✦</span> New Brand
            </button>

            {/* User menu */}
            <UserMenu session={session} onSignOut={onSignOut} onGoToTab={(id) => setTab(id)} currentPlan={session?.plan || 'discover'} />
          </div>
        </header>

        {/* ── CONTENT ── */}
        <main className="db-content">

          {/* ── HERO ── */}
          <div className="db-hero">
            <div className="db-greeting">
              {getGreeting()}{firstName ? `, ${firstName}` : ''}.
            </div>
            <div className="db-greeting-sub">
              {brands.length === 0
                ? 'Your brand studio is ready. Build your first brand.'
                : `You have ${brands.length} brand${brands.length !== 1 ? 's' : ''} in your studio.`
              }
            </div>

            {/* Generation count bar */}
            {planLimit > 0 && !loading && (
              <div style={{ marginTop:'20px', display:'inline-flex', alignItems:'center', gap:'16px', background:'#FFFFFF', border:`1px solid ${isEmpty ? '#FECACA' : isLow ? '#FDE68A' : '#E2E8F0'}`, borderRadius:'12px', padding:'12px 20px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
                <div>
                  <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'22px', fontWeight:'700', letterSpacing:'-0.03em', color: isEmpty ? '#DC2626' : isLow ? '#D97706' : '#0A0A1A', lineHeight:1 }}>
                    {generationsRemaining}
                    <span style={{ fontSize:'13px', fontWeight:'500', color:'#9CA3AF', marginLeft:'4px' }}>/ {planLimit} remaining</span>
                  </div>
                  <div style={{ fontSize:'11px', color:'#9CA3AF', marginTop:'3px', textTransform:'uppercase', letterSpacing:'0.08em' }}>Brand generations</div>
                </div>

                {/* Progress bar */}
                <div style={{ width:'120px' }}>
                  <div style={{ height:'6px', background:'#F3F4F6', borderRadius:'3px', overflow:'hidden' }}>
                    <div style={{ height:'100%', width:`${usagePercent}%`, background: isEmpty ? '#EF4444' : isLow ? '#F59E0B' : '#1A6AFF', borderRadius:'3px', transition:'width 0.6s ease' }} />
                  </div>
                  <div style={{ fontSize:'10px', color:'#9CA3AF', marginTop:'4px' }}>
                    {generationsUsed} used
                  </div>
                </div>

                {(isEmpty || isLow) && (
                  <a
                    href="https://www.brandostro.com/pricing"
                    target="_blank"
                    rel="noreferrer"
                    style={{ height:'34px', padding:'0 16px', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'12px', fontWeight:'600', color:'#fff', cursor:'pointer', display:'flex', alignItems:'center', textDecoration:'none', whiteSpace:'nowrap', boxShadow:'0 2px 8px rgba(26,106,255,0.25)' }}
                  >
                    {isEmpty ? 'Get More Brands →' : 'Upgrade →'}
                  </a>
                )}
              </div>
            )}
          </div>

          {/* ── STATS ── */}
          <div className="db-stats">
            {[
              { icon:'🏷️', num: brands.length, label:'Brands Built' },
              { icon:'⚡', num: generations.length, label:'Total Generations' },
              { icon:'📅', num: brands[0] ? formatDate(brands[0].created_at) : '—', label:'Last Brand' },
              { icon:'📋', num: plan.label, label:'Active Plan' },
            ].map((s,i) => (
              <div key={i} className="db-stat">
                <span className="db-stat-icon">{s.icon}</span>
                <div className="db-stat-num">{s.num}</div>
                <div className="db-stat-label">{s.label}</div>
              </div>
            ))}
          </div>

          {/* ── TABS ── */}
          <div className="db-tabs">
            {TABS.map(t => (
              <button key={t.id} className={`db-tab ${tab===t.id?'active':''}`} onClick={() => setTab(t.id)}>
                {t.label}
              </button>
            ))}
          </div>

          {/* ── LOADING ── */}
          {loading && (
            <div style={{ textAlign:'center', padding:'80px 0' }}>
              <div className="db-spinner" />
              <div style={{ fontSize:'13px', color:'#9CA3AF' }}>Loading your studio...</div>
            </div>
          )}

          {/* ── ERROR ── */}
          {error && !loading && (
            <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:'12px', padding:'16px 20px', marginBottom:'24px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:'13px', color:'#FCA5A5' }}>{error}</span>
              <button onClick={loadData} style={{ fontSize:'12px', color:'#1A6AFF', background:'none', border:'none', cursor:'pointer', fontWeight:'600' }}>Retry</button>
            </div>
          )}

          {/* ── MY BRANDS ── */}
          {!loading && tab === 'brands' && (
            <div className="db-brands-grid">
              {brands.map(brand => {
                const accentColor = brand.brand_data?.phase03?.colors?.primary?.hex || '#1A6AFF';
                const secondaryColor = brand.brand_data?.phase03?.colors?.secondary?.hex || '#06B6D4';
                return (
                  <div key={brand.id} className="db-brand-card" onClick={() => openBrand(brand.id)}>
                    <div className="db-card-accent" style={{ background:`linear-gradient(90deg,${accentColor},${secondaryColor})` }} />
                    <div className="db-card-body">
                      <div className="db-card-top">
                        {brand.logo_url ? (
                          <div className="db-card-logo" style={{ background:`${accentColor}20` }}>
                            <img src={brand.logo_url} alt={brand.brand_name} style={{ width:'100%', height:'100%', objectFit:'contain' }} />
                          </div>
                        ) : (
                          <div className="db-card-logo" style={{ background:`${accentColor}20`, color: accentColor }}>
                            {(brand.brand_name || 'B').charAt(0).toUpperCase()}
                          </div>
                        )}
                        <div>
                          <div className="db-card-name">{brand.brand_name}</div>
                          <div className="db-card-date">{formatDate(brand.created_at)}</div>
                        </div>
                      </div>
                      {brand.brief && (
                        <div className="db-card-brief">{brand.brief}</div>
                      )}
                      <div className="db-card-footer">
                        <div style={{ display:'flex', gap:'6px' }}>
                          {[accentColor, secondaryColor].map((c,i) => (
                            <div key={i} style={{ width:'10px', height:'10px', borderRadius:'50%', background:c, opacity:0.8 }} />
                          ))}
                        </div>
                        <div className="db-card-open">Continue →</div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* New brand card */}
              <div className="db-new-card" onClick={handleNewBrand}>
                <div className="db-new-icon">✦</div>
                <div className="db-new-label">Build a New Brand</div>
              </div>
            </div>
          )}

          {/* ── BRAND ACTIVITY ── */}
          {!loading && tab === 'activity' && (
            <div className="db-activity">
              <div className="db-activity-header">
                <div className="db-activity-title">{generations.length} action{generations.length !== 1 ? 's' : ''} on record</div>
                {generations.length > 0 && (
                  <button className="db-csv-btn" onClick={() => downloadCSV(generations)}>↓ Export CSV</button>
                )}
              </div>

              {generations.length === 0 ? (
                <div className="db-empty">
                  <div className="db-empty-icon">⚡</div>
                  <div className="db-empty-title">No activity yet</div>
                  <div className="db-empty-sub">Build your first brand and your activity will appear here.</div>
                  <button className="db-nav-cta" onClick={handleNewBrand} style={{ margin:'0 auto' }}>✦ Build My First Brand</button>
                </div>
              ) : (
                <div className="db-table">
                  <div className="db-table-head">
                    {['Date','Brand','Action','Plan',''].map((h,i) => (
                      <div key={i} className="db-th">{h}</div>
                    ))}
                  </div>
                  {generations.map((g,i) => {
                    const am = ACTION_META[g.action] || { label: g.action, icon:'·', color:'#6B7280' };
                    const pm = PLAN_META[g.plan] || PLAN_META.none;
                    const isClickable = !!g.brand_id;
                    return (
                      <div key={g.id || i} className="db-table-row"
                        onClick={() => isClickable && openBrand(g.brand_id)}
                        style={{ cursor: isClickable ? 'pointer' : 'default' }}
                        title={isClickable ? `Open ${g.brand_name}` : ''}
                      >
                        <div className="db-td db-td-date">{formatDate(g.created_at)}</div>
                        <div className="db-td db-td-name" style={{ color: isClickable ? '#1A6AFF' : '#0A0A1A', display:'flex', alignItems:'center', gap:'6px' }}>
                          {g.brand_name || '—'}
                          {isClickable && <span style={{ fontSize:'10px', opacity:0.5 }}>↗</span>}
                        </div>
                        <div className="db-td">
                          <span className="db-action-badge" style={{ background:`${am.color}15`, color:am.color, border:`1px solid ${am.color}30` }}>
                            {am.icon} {am.label}
                          </span>
                        </div>
                        <div className="db-td">
                          <span style={{ fontSize:'11px', fontWeight:'600', color:pm.color, textTransform:'uppercase', letterSpacing:'0.08em' }}>
                            {pm.label}
                          </span>
                        </div>
                        <div className="db-td" />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* ── MY PLAN ── */}
          {!loading && tab === 'plan' && (
            <div className="db-plan-card">
              <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'32px' }}>
                <div>
                  <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:'8px' }}>Current Plan</div>
                  <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'36px', fontWeight:'700', letterSpacing:'-0.04em', color:'#0A0A1A', marginBottom:'8px' }}>{plan.label}</div>
                  <div style={{ fontSize:'14px', color:'#6B7280' }}>{plan.desc}</div>
                </div>
                <div className="db-plan-pill" style={{ background:plan.bg, border:`1px solid ${plan.border}`, color:plan.color, fontSize:'11px', padding:'8px 16px' }}>
                  Active
                </div>
              </div>

              <div className="db-inline-grid-3" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px', marginBottom:'32px' }}>
                {[
                  { label:'Brands Built', value:brands.length },
                  { label:'Total Generations', value:generations.length },
                  { label:'Member Since', value:brands[0] ? new Date(brands[0].created_at).toLocaleDateString('en-GB',{month:'short',year:'numeric'}) : 'Just joined' },
                ].map((s,i) => (
                  <div key={i} style={{ background:'#F8FAFF', border:'1px solid #E2E8F0', borderRadius:'12px', padding:'20px' }}>
                    <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'24px', fontWeight:'700', letterSpacing:'-0.03em', color:'#0A0A1A', marginBottom:'4px' }}>{s.value}</div>
                    <div style={{ fontSize:'11px', color:'#9CA3AF', textTransform:'uppercase', letterSpacing:'0.1em' }}>{s.label}</div>
                  </div>
                ))}
              </div>

              {session?.plan !== 'pro' && (
                <div style={{ background:'linear-gradient(135deg,rgba(26,106,255,0.1),rgba(6,182,212,0.05))', border:'1px solid rgba(26,106,255,0.2)', borderRadius:'16px', padding:'24px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                  <div>
                    <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'16px', fontWeight:'700', color:'#0A0A1A', marginBottom:'4px' }}>Upgrade to Brand Pro</div>
                    <div style={{ fontSize:'13px', color:'#6B7280' }}>50 generations per year · All 10 phases · Priority processing · Every future feature</div>
                  </div>
                  <a href="https://buy.polar.sh/polar_cl_T7PDbvmeACaU1y4lTw2Jzsi3WwYx2k2wJlUIC4e83cM" target="_blank" rel="noreferrer" style={{ height:'40px', padding:'0 24px', background:'linear-gradient(135deg,#0E7490,#06B6D4)', border:'none', borderRadius:'8px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'13px', fontWeight:'600', color:'#fff', cursor:'pointer', display:'flex', alignItems:'center', textDecoration:'none', flexShrink:0, marginLeft:'24px' }}>
                    Upgrade to Pro →
                  </a>
                </div>
              )}
            </div>
          )}

          {/* ── SUPPORT ── */}
          {!loading && tab === 'support' && (
            <BrandostroAssistant session={session} engineUrl={engineUrl} />
          )}

          {!loading && tab === 'account' && (
            <AccountPage session={session} onSignOut={onSignOut} />
          )}
        </main>
      </div>
      {/* ── GENERATION EXHAUSTED MODAL ── */}
      {showUpgradeModal && (
        <div style={{ position:'fixed', inset:0, zIndex:500, background:'rgba(4,7,13,0.7)', backdropFilter:'blur(16px)', display:'flex', alignItems:'flex-start', justifyContent:'center', padding:'40px 24px', overflowY:'auto' }}
          onClick={() => setShowUpgradeModal(false)}>
          <div style={{ background:'#FFFFFF', borderRadius:'20px', padding:'40px', maxWidth:'460px', width:'100%', textAlign:'center' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ fontSize:'40px', marginBottom:'16px' }}>⚡</div>
            <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:'22px', fontWeight:'700', letterSpacing:'-0.03em', color:'#0A0A1A', marginBottom:'8px' }}>
              You have used all {planLimit} generation{planLimit !== 1 ? 's' : ''}
            </div>
            <div style={{ fontSize:'14px', color:'#6B7280', lineHeight:'1.7', marginBottom:'28px' }}>
              {session?.plan === 'discover'
                ? 'Your Discover plan includes 1 brand generation. Upgrade to Brand Studio for 5 complete brand sessions, your logo, website, company profile and full exports.'
                : session?.plan === 'studio'
                ? 'Your Brand Studio plan includes 5 brand sessions. Upgrade to Brand Pro for 50 generations per year, priority processing and every new feature.'
                : 'You have used all your Brand Pro generations for this period. Contact us if you need additional capacity.'
              }
            </div>
            <a href={session?.plan === 'studio'
                ? "https://buy.polar.sh/polar_cl_sk7lc4uYk9oP5ae3RFWL6lwFLzj4LcSb5xnTl0xHbzA"
                : session?.plan === 'pro'
                ? "mailto:info@brandostro.com?subject=Brand Pro Capacity"
                : "https://buy.polar.sh/polar_cl_T7PDbvmeACaU1y4lTw2Jzsi3WwYx2k2wJlUIC4e83cM"}
              target="_blank" rel="noreferrer"
              style={{ display:'block', height:'50px', lineHeight:'50px', background:'linear-gradient(135deg,#094BCC,#1A6AFF)', borderRadius:'10px', fontFamily:"'Space Grotesk',sans-serif", fontSize:'15px', fontWeight:'600', color:'#fff', textDecoration:'none', marginBottom:'12px', boxShadow:'0 6px 24px rgba(26,106,255,0.3)' }}>
              {session?.plan === 'pro' ? 'Contact Us →' : session?.plan === 'studio' ? 'Upgrade to Brand Pro →' : 'Upgrade to Brand Studio →'}
            </a>
            <button onClick={() => setShowUpgradeModal(false)}
              style={{ background:'none', border:'none', fontSize:'13px', color:'#9CA3AF', cursor:'pointer' }}>
              Dismiss
            </button>
          </div>
        </div>
      )}
    </>
  );
}
